import { Skeleton } from '@/ui/core/skeleton'
import { VStack } from '@/ui/core/stack'

/** Sits on the page ground, never inside a card, where a pale skeleton would be invisible. */
export const SchedulePickerSkeleton = () => (
	<VStack gap={20}>
		<Skeleton isLoading className="h-8 w-1/2" />
		<Skeleton isLoading className="h-40 w-full" />
		<Skeleton isLoading className="h-20 w-full" />
		<Skeleton isLoading className="h-20 w-full" />
	</VStack>
)
